<template>
  <button class="buy-now__shared">SOLD OUT</button>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
p {
  @include on-desktop() {
    font-size: 1.25rem;
  }
}
</style>
